import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PodcastsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"podcasts"}/>
}
